/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 5:47:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ActionDialog } from "ui-widgets/dialogs/GenericDialogs";
import { useGlobalScope } from "core/providers";

export const InstallationConfirmationComponent = ({
  isAlreadyInstalled,
  serviceTitle,
  installationConfirmationOpenState,
  closeInstallationConfirmation,
  handleConfirmInstallation,
}) => {
  const { selectedOrganization } = useGlobalScope().globalState;

  const confirmationTitle = `${isAlreadyInstalled ? "Update" : "Install"} ${serviceTitle}`;

  return (
    <>
      <ActionDialog
        severity="warning"
        title={confirmationTitle}
        open={installationConfirmationOpenState}
        onClose={closeInstallationConfirmation}
        confirmationAction={() => {
          handleConfirmInstallation();
          closeInstallationConfirmation();
        }}
        dialogMessage={
          isAlreadyInstalled ? (
            <>
              <p>
                <b>{serviceTitle}</b> service template is already installed and running for{" "}
                <b>{selectedOrganization.name}</b>.
              </p>
              <p>Updating it may ovewrite any changes you have made to the service built from this template.</p>
              <p>Are you sure about this?</p>
            </>
          ) : (
            <>
              <p>
                You are about to install the <b>{serviceTitle}</b> service template to the organization named{" "}
                <b>{selectedOrganization.name}</b>
              </p>
            </>
          )
        }
      />
    </>
  );
};
